import * as React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

const styles = (theme) => ({
  loading: {
    position: "fixed",
    width: "100%",
    height: "100%",
    background: `rgba(0, 0, 0, 0.4)`,
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 9999,
    color: theme.palette.common.white,
  },
});

const Loading = connect( (state) => ({ logo: state.app.logo }) )( ({ classes, logo }) => {
  return (
    <section className={classes.loading}>
      {
        logo && <i
          style={{
            background: `url(${logo}) center center / auto 100% no-repeat`,
            height: 80,
            width: 160,
          }}
        />
      }
      Loading ...
    </section>
  );
} );

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx